module.exports = __webpack_public_path__ + "img/icons8_memories.ebcb740a.png";